// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xGoogleAnalyticsState } from "@guestsupply/App/Store/Reducers";
import { getDataLayer } from "@guestsupply/App/Utilities/DataLayer";
import { GOOGLE_EVENTS } from "@guestsupply/XDL/constants";
import { ApiHandler, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";

type HandlerType = ApiHandler<{
    userEmail: string;
    accountAppFor: string;
}>;

export const XngGaRequestRegistration: HandlerType = props => {
    const state = props.getState() as xGoogleAnalyticsState;

    const { userEmail, accountAppFor } = props.parameter;

    if (state.xGoogleAnalytics.includeRegistrationEvent) {
        const dataLayer = getDataLayer();

        if (!dataLayer) {
            return;
        }

        const googleAnalyticsData = {
            event: GOOGLE_EVENTS.REGISTRATION,
            user: userEmail,
            acct_app_for: accountAppFor,
        };

        dataLayer.push(googleAnalyticsData);
    }
};

export const chain = [XngGaRequestRegistration];

const xngGaRegistrationEvent = createHandlerChainRunner(chain, "XngGaRegistrationEvent");
export default xngGaRegistrationEvent;
